import styled from 'styled-components'

// `MenuListItem` is used without `MenuList`, which ships its own trigger
// button and would cost a second click inside an open popover.
export const ChatMenuStyled = styled.div`
  min-width: 14rem;
  padding: 0.25rem 0;
`
